<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <div class='btn-toolbar pull-right'>
          <div class='btn-group'>
            <a class="btn btn-primary btn-sm btn-action" href="#!/funcoes/new" uib-tooltip="Nova Função" tooltip-placement="left" ng-if="permissions.funcao.canManage">
              Nova <i class="fa fa-plus"></i>
            </a>
          </div>
        </div>
        <h2>Funções</h2>
      </div>
    </div>
  </div>

  <div class="row" ng-include="'views/funcoes/_filtros.html'"></div>
  <div class="row" ng-include="'views/funcoes/_list.html'"></div>
</page-data-manager>
